import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { GameField } from 'widgets/game-field';
import { IS_STEPBALL } from 'shared/config';
import chezaSrc from 'shared/ui/assets/icons/chezachini-logo.svg';
import slapSrc from 'shared/ui/assets/icons/stepball-logo.svg';
import { resultModel } from '../model';
import cls from './result-page.module.scss';

export const ResultPage = () => {
	const { t } = useTranslation();
	const result = useUnit(resultModel.$result);
	const logoSrc = IS_STEPBALL ? slapSrc : chezaSrc;

	return (
		<main className={cls.resultWrapper}>
			<section className={cls.resultSection}>
				<img
					alt='logo'
					src={logoSrc}
					className={cls.resultLogo}
				/>
				<div className={cls.resultTable}>
					<div className={cls.resultRow}>
						<div className={cls.resultCell}>{t('result.round-id')}</div>
						<div className={cls.resultCell}>{result?.roundId}</div>
					</div>
					<div className={cls.resultRow}>
						<div className={cls.resultCell}>{t('result.status')}</div>
						<div className={cls.resultCell}>{result?.status}</div>
					</div>
					<div className={cls.resultRow}>
						<div className={cls.resultCell}>{t('result.total-bet')}</div>
						<div className={cls.resultCell}>{result?.totalBet}</div>
					</div>
					<div className={cls.resultRow}>
						<div className={cls.resultCell}>{t('result.total-win')}</div>
						<div className={cls.resultCell}>{result?.totalWin}</div>
					</div>
					<div className={cls.resultRow}>
						<div className={cls.resultCell}>{t('result.currency')}</div>
						<div className={cls.resultCell}>{result?.currency}</div>
					</div>
				</div>
				<GameField className={cls.resultField} />
			</section>
		</main>
	);
};
